import styled from '@emotion/styled';
import { settingsTheme as t } from '../theme';

interface DescriptionProps {
  /** `page` para el subtítulo de la vista; `card` para el texto de una tarjeta. */
  size?: 'page' | 'card';
  /** Atenúa el texto a gris claro para estados deshabilitados. */
  muted?: boolean;
}

const SIZES = {
  page: { fontSize: '14.5px' },
  card: { fontSize: '13.5px' },
} as const;

/**
 * Primitivo de texto secundario (gris). Acompaña siempre a un `Title`.
 */
const Description = styled.p<DescriptionProps>(({ size = 'card', muted = false }) => ({
  margin: 0,
  fontFamily: t.font,
  color: muted ? t.color.disabledText : t.color.muted,
  lineHeight: 1.5,
  ...SIZES[size],
}));

export default Description;
